
import Aura from '@primevue/themes/aura';
import {definePreset} from "@primevue/themes";

const MakeupArtist = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#fbeaec',  // Lightest shade of your color
            100: '#f4c5cd',
            200: '#eda0ad',
            300: '#e57b8d',
            400: '#dd566e',
            500: '#974C5E',  // Base color
            600: '#7b3c4b',
            700: '#5f2d38',
            800: '#432025',
            900: '#271211',
            950: '#15090a'   // Darkest shade
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#974C5E',
                    inverseColor: '#ffffff',
                    hoverColor: '#dd566e',  // Slightly lighter for hover
                    activeColor: '#e57b8d' // Lighter shade for active state
                },
                highlight: {
                    background: '#974C5E',
                    focusBackground: '#7b3c4b',
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            },
            dark: {
                primary: {
                    color: '#fbeaec',
                    inverseColor: '#271211',
                    hoverColor: '#f4c5cd',
                    activeColor: '#eda0ad'
                },
                highlight: {
                    background: 'rgba(151, 76, 94, 0.16)',
                    focusBackground: 'rgba(151, 76, 94, 0.24)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    }
});

export default MakeupArtist;
